document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('klaviyo-form:opened', e => {
    const formId = e.detail.formId
    const observer = {
      retry: 10
    }
    const interval = setInterval(() => {
      observer.retry--
      observer.klaviyoForm = document.querySelector(`[data-testid="klaviyo-form-${formId}"]`)

      if (observer.klaviyoForm || observer.retry <= 0) {
        const klaviyoContainer = observer.klaviyoForm.closest('[role="dialog"]')
        klaviyoContainer && klaviyoContainer.setAttribute('aria-live', 'polite')
        clearInterval(interval)
      }
    }, 1000)
  })
})
